export default "__VITE_ASSET__DN8v$Q2b__"